import { useAuth } from "context/AuthContext";
import {
  Building,
  Calendar,
  Mail,
  MapPin,
  Phone,
  User,
  UserCircle,
} from "lucide-react";
import { FC } from "react";
import { CivilCaseComplaint, CivilCaseComplaintStatus } from "types";
import { DateView } from "utils/helper";

type Props = {
  complaint: CivilCaseComplaint | undefined;
  setRefetch: any;
};

const CivilCaseComplaintInformationTab: FC<Props> = ({
  complaint,
  setRefetch,
}) => {
  const { loginData } = useAuth();

  const clientInfoFields = [
    {
      label: "Full Name",
      value: complaint?.client_full_name ?? "-",
      icon: <User className="w-4 h-4" />,
    },
    {
      label: "Gender",
      value: complaint?.gender ?? "-",
      icon: <UserCircle className="w-4 h-4" />,
    },
    // {
    //   label: "Nationality",
    //   value: complaint?.nationality ?? "-",
    // },
    {
      label: "Phone Number",
      value: complaint?.phone_number ?? "-",
      icon: <Phone className="w-4 h-4" />,
    },
    {
      label: "Email",
      value: complaint?.email ?? "-",
      icon: <Mail className="w-4 h-4" />,
    },
    {
      label: "Region",
      value: complaint?.region ?? "-",
      icon: <MapPin className="w-4 h-4" />,
    },
    {
      label: "Zone/City",
      value: complaint?.zone_or_city ?? "-",
      icon: <MapPin className="w-4 h-4" />,
    },
    {
      label: "Woreda",
      value: complaint?.woreda_or_kebele ?? "-",
      icon: <MapPin className="w-4 h-4" />,
    },
    {
      label: "Sub City",
      value: complaint?.sub_city ?? "-",
      icon: <MapPin className="w-4 h-4" />,
    },
    {
      label: "Kebele",
      value: complaint?.kebele ?? "-",
      icon: <MapPin className="w-4 h-4" />,
    },
    {
      label: "House Number",
      value: complaint?.house_number ?? "-",
      icon: <MapPin className="w-4 h-4" />,
    },
    {
      label: "Service Place",
      value: loginData?.structure?.admin_unit?.unit_name ?? "-",
      icon: <Building className="w-4 h-4" />,
    },
    {
      label: "Incident Date",
      value: complaint?.incident_date ? DateView(complaint.incident_date) : "-",
      icon: <Calendar className="w-4 h-4" />,
    },
  ];

  const assignProsecutorFields = [
    {
      label: "Assigned To",
      value: complaint?.assgined_prosecutor ?? "-",
      icon: <User className="w-4 h-4" />,
    },
    {
      label: "Coordinator",
      value: complaint?.cordinator_name ?? "-",
      icon: <UserCircle className="w-4 h-4" />,
    },
  ];

  return (
    <div className="flex-1 min-w-[350px]">
      <div className="bg-white rounded-xl shadow-lg p-6 space-y-8">
        {/* Header Section */}
        {/* <div className="border-b pb-4">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-xl font-bold text-gray-900">
                Complaint on Prosecutor
              </h1>
              <div className="flex items-center gap-2 mt-1">
                <div className="px-3 py-1 bg-red-100 text-red-800 text-sm font-medium rounded-full">
                  Case ID: {complaint?.client_id || "N/A"}
                </div>
                {loginData?.org_unit !== complaint?.org_unit_id && (
                  <div className="px-3 py-1 bg-amber-100 text-amber-800 text-sm font-medium rounded-full">
                    Forwarded Case
                  </div>
                )}
              </div>
            </div>
            {complaint?.created_at && (
              <div className="text-sm text-gray-500">
                Filed on: {new Date(complaint.created_at).toLocaleDateString()}
              </div>
            )}
          </div>
        </div> */}

        {/* Client Information */}
        <div className="space-y-4">
          <div className="flex items-center gap-2">
            <div className="w-1 h-6 bg-red-600 rounded-full"></div>
            <h3 className="text-lg font-semibold text-gray-900">
              Client Information
            </h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {clientInfoFields.map((item) => (
              <div
                key={item.label}
                className="flex items-start p-3 rounded-lg hover:bg-gray-50 transition-colors border border-gray-100"
              >
                {item.icon && (
                  <div className="mr-3 mt-1 text-gray-400">{item.icon}</div>
                )}
                <div className="flex-1">
                  <dt className="text-sm font-medium text-gray-500 mb-1">
                    {item.label}
                  </dt>
                  <dd
                    className={`font-medium ${item.value === "-" ? "text-gray-400" : "text-gray-900"}`}
                  >
                    {item.value}
                  </dd>
                </div>
              </div>
            ))}

            {/* {loginData?.org_unit !== complaint?.org_unit_id &&
              forwardedFrom && (
                <div className="flex items-start p-3 rounded-lg bg-amber-50 border border-amber-100 md:col-span-2">
                  <div className="mr-3 mt-1 text-amber-600">
                    <svg
                      className="w-4 h-4"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <div className="flex-1">
                    <dt className="text-sm font-medium text-amber-700 mb-1">
                      Forwarded From
                    </dt>
                    <dd className="font-semibold text-amber-800">
                      {forwardedFrom}
                    </dd>
                    <p className="text-xs text-amber-600 mt-1">
                      This complaint was forwarded to your department
                    </p>
                  </div>
                </div>
              )} */}
          </div>
        </div>

        {complaint?.status === "assigned_to_prosecutor" && (
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <div className="w-1 h-6 bg-red-600 rounded-full"></div>
              <h3 className="text-lg font-semibold text-gray-900">
                Prosecutor Assign Information
              </h3>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {assignProsecutorFields.map((item) => (
                <div
                  key={item.label}
                  className="flex items-start p-3 rounded-lg hover:bg-gray-50 transition-colors border border-gray-100"
                >
                  {item.icon && (
                    <div className="mr-3 mt-1 text-gray-400">{item.icon}</div>
                  )}
                  <div className="flex-1">
                    <dt className="text-sm font-medium text-gray-500 mb-1">
                      {item.label}
                    </dt>
                    <dd
                      className={`font-medium ${item.value === "-" ? "text-gray-400" : "text-gray-900"}`}
                    >
                      {item.value}
                    </dd>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Accused Information */}
        <div className="space-y-6">
          <div className="flex items-center gap-2">
            <div className="w-1 h-6 bg-red-600 rounded-full"></div>
            <h2 className="text-lg font-semibold text-gray-900">
              Accused Information
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="p-4 bg-red-50/50 rounded-lg border border-red-100">
              <label className="block text-sm font-medium text-red-700 mb-1">
                Accused Person Name
              </label>
              <p
                className={`font-medium ${!complaint?.accused_person_name ? "text-gray-400" : "text-gray-900"}`}
              >
                {complaint?.accused_person_name || "Not specified"}
              </p>
            </div>
            <div className="p-3 rounded-lg border border-gray-100">
              <dt className="text-sm font-medium text-gray-500 mb-1">
                Accused Department
              </dt>
              <dd
                className={`font-medium ${!complaint?.unit_name ? "text-gray-400" : "text-gray-900"}`}
              >
                {complaint?.unit_name || "Not specified"}
              </dd>
            </div>
          </div>
        </div>

        {/* Complaint Summary & Requested Resolution */}
        <div className="grid grid-cols-1 lg:grid-cols-1 gap-6">
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <div className="w-1 h-5 bg-amber-600 rounded-full"></div>
              <h3 className="text-base font-semibold text-gray-900">
                Complaint Summary
              </h3>
            </div>
            <div className="p-4 bg-amber-50/50 rounded-lg border border-amber-100 min-h-[120px]">
              {complaint?.complaint_summary ? (
                <p className="text-gray-700 whitespace-pre-line leading-relaxed">
                  {complaint.complaint_summary}
                </p>
              ) : (
                <p className="text-gray-400 italic">No summary provided</p>
              )}
            </div>
          </div>

          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <div className="w-1 h-5 bg-green-600 rounded-full"></div>
              <h3 className="text-base font-semibold text-gray-900">
                Requested Resolution
              </h3>
            </div>
            <div className="p-4 bg-green-50/50 rounded-lg border border-green-100 min-h-[120px]">
              {complaint?.requested_resolution ? (
                <p className="text-gray-700 whitespace-pre-line leading-relaxed">
                  {complaint.requested_resolution}
                </p>
              ) : (
                <p className="text-gray-400 italic">No resolution requested</p>
              )}
            </div>
          </div>
        </div>

        {/* Forwarding Information */}
        {/* {loginData?.org_unit !== complaint?.org_unit_id && forwardedFrom && (
          <div className="mt-6 p-4 bg-red-50 rounded-lg border border-red-100">
            <div className="flex items-start">
              <div className="flex-1">
                <h4 className="text-base font-semibold text-red-800 mb-2">
                  Forwarded Information
                </h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  <div>
                    <label className="block text-sm font-medium text-red-600 mb-1">
                      Forwarded From
                    </label>
                    <p className="font-semibold text-red-900">
                      {forwardedFrom}
                    </p>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-red-600 mb-1">
                      Forwarded To
                    </label>
                    <p className="font-semibold text-red-900">
                      {loginData?.structure?.admin_unit?.unit_name ||
                        "Your Department"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )} */}

        <div className="pt-4 border-t border-gray-200">
          <div className="flex flex-wrap items-center gap-4 text-sm text-gray-500">
            {complaint?.created_at && (
              <div className="flex items-center gap-1">
                <Calendar className="w-4 h-4" />
                <span>Filed: {DateView(complaint.created_at)}</span>
              </div>
            )}
            {complaint?.status && (
              <div className="px-2 py-1 rounded-full bg-red-100 text-red-800 text-xs font-medium">
                Status: {CivilCaseComplaintStatus[complaint.status]}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CivilCaseComplaintInformationTab;
